import React, { useCallback } from 'react';
import { Field, useField } from 'react-final-form';

import FormInput from 'Shared/components/FormComponents/FormInput';
import {
  validEmailOrEmptyRequired,
  useValidator,
  nonConsistsOfAllSpacesStringRequired,
} from 'Shared/utils/formValidations';
import { WpIcon } from 'Wpds/components/icon';

type PropType = {
  remove: Function;
  name: string;
  fieldsCount: number;
  uuid: string;
  index: number;
};

export default function FormField({ name, uuid, remove, fieldsCount, index }: PropType) {
  const {
    input: { onChange },
  } = useField('currentWorkspace');
  const nameValidate = useValidator(nonConsistsOfAllSpacesStringRequired, 'This field is required');

  const handleRemove = useCallback(() => {
    remove(index);
  }, [remove, index]);

  const handleChange = useCallback(() => {
    onChange(uuid);
  }, [uuid, onChange]);

  return (
    <div key={name}>
      <div className="d-flex align-items-start mb-2">
        <Field
          inputClassName="onboarding-field shadow-none"
          name={`${name}.fullName`}
          validate={nameValidate}
          component={FormInput}
          placeholder="Full name"
          autoComplete="off"
          onInputFocus={handleChange}
        />
        <div className="w-100">
          <Field
            inputClassName="ml-2 onboarding-email-field shadow-none"
            name={`${name}.email`}
            component={FormInput}
            placeholder="Email (optional)"
            validate={validEmailOrEmptyRequired}
            autoComplete="off"
            onInputFocus={handleChange}
            errorLabel={false}
          />
          <Field name={`${name}.email`}>
            {({ input: { value }, meta: { error, touched } }) =>
              error && touched && value ? (
                <div className="alert alert-danger p-2 mt-2 ml-2 w-100" role="alert">
                  {error}
                </div>
              ) : null
            }
          </Field>
        </div>
        {fieldsCount > 1 && (
          <div className="onboarding-workspaces-field-delete-icon mt-2" onClick={handleRemove}>
            <WpIcon name="times-circle" />
          </div>
        )}
      </div>
    </div>
  );
}
